import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05f92350"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "client_tabs_menu" }
const _hoisted_2 = { class: "back_button_wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "back_button_img",
  src: "/assets/img/arrow-left.svg"
}, null, -1))

export function render(_ctx, _cache) {
  const _component_v_scrollable_menu = _resolveComponent("v-scrollable-menu")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.clickOnBackButton && _ctx.clickOnBackButton(...args))),
        class: "button_back"
      }, [
        _hoisted_3,
        _createElementVNode("span", null, _toDisplayString(_ctx.backButton?.isNeedTranslatedButtonText && _ctx.backButton?.buttonText ? _ctx.$t(_ctx.backButton.buttonText) : _ctx.backButton?.buttonText), 1)
      ], 512), [
        [_vShow, _ctx.backButton?.buttonPath]
      ])
    ]),
    _createVNode(_component_v_scrollable_menu, {
      modelValue: _ctx.activeTabItem,
      items: _ctx.tabs,
      badges: _ctx.badges,
      "onUpdate:modelValue": _ctx.onTabClick
    }, null, 8, ["modelValue", "items", "badges", "onUpdate:modelValue"])
  ]))
}